var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover"},[(_vm.music.cover)?_c('img',{attrs:{"src":_vm.music.cover,"alt":"cover"}}):_vm._e(),(_vm.music.isPlaying)?_c('div',{staticClass:"cover--activate"},[_vm._v(_vm._s(_vm._f("formatMusicTime")(_vm.currentTime)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }